import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

const CIRCLE_SIZE = 40;

export const useStyles = makeStyles<Theme>()((theme) => ({
  signUpWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: MAX_PAGE_HEIGHT,
    padding: theme.spacing(2, 0),
  },
  signUpContentWrapper: {
    ...theme.mixins.appContainer,
    width: '480px',
    padding: theme.spacing(4, 2),

    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      minHeight: MAX_PAGE_HEIGHT,
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  desktopLanguageSelector: {
    position: 'fixed',
    top: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: theme.zIndex.appBar,
  },
  mobileLanguageSelector: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
  wizardForm: {
    width: '100%',
  },
  stepTitle: {
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  stepContent: {
    '& > div + div': {
      marginTop: theme.spacing(2),
    },
  },
  textField: {
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(2),
    },
  },
  measurementRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  measurementFields: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',

    '& > div:first-of-type': {
      flex: 1,
      minWidth: 0,
    },
    '& > div:last-of-type': {
      width: '120px',
      flexShrink: 0,
    },
  },
  colorSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  colorCirclesRow: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  colorCircle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: '50%',
    cursor: 'pointer',
    border: '3px solid transparent',
    transition: 'border-color 0.2s, transform 0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  colorCircleSelected: {
    borderColor: theme.palette.text.primary,
  },
  themeRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  functionalityHint: {
    marginBottom: theme.spacing(2),
    color: theme.palette.font.secondary,
  },
  labelWithTooltip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  restRow: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    minWidth: 0,
    gap: theme.spacing(1),

    '& > div:first-of-type': {
      flex: 1,
      minWidth: 0,
    },
  },
  restInput: {
    flex: 1,
    minWidth: 0,
  },
  resetButton: {
    flexShrink: 0,
  },
  actionsRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(4),
  },
  skipInfoContent: {
    padding: theme.spacing(1, 0, 2),
  },
}));
